module.exports = __webpack_public_path__ + "img/wavecurtain.51131484.png";